<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                     <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Terminal">
                                <a-select v-model="inputTerminal" showSearch placeholder="All Terminals" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0" :show-labels="false" :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :fields="fields_export" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                inputTerminal: 0,
                site_type: "ho",
                siteOptions: [],
                terminalOptions: [],
                allTerminals: [],
                cashierOptions: [],
                birSalesReports: [],
                JsonData: [],
                fields_export:{ // this is to empty the header / first row and assign the 0 - 3 as array key 
                    ' ': '0',
                    '  ': '1',
                    '   ': '2',
                    '    ': '3',
                    '     ': '4'
                } 
            }
        },
        watch: {
            inputSite(newSiteIds) {
              this.updateTerminaOptions(newSiteIds)
            },
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }


            let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
            component_x.terminalOptions = terminals;
            component_x.terminalOptions.push({id: 0, name: ' All Terminals'})
            // component_x.sort(component_x.terminalOptions);
            component_x.terminalOptions = this.terminalOptions.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });

    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
    },
    components: {
        VueJsonToCsv
    },
    methods: {
        moment,
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        sort(data) {
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        async updateTerminaOptions(siteId) {
            let terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
            this.terminalOptions = terminals;
            this.terminalOptions.push({ id: 0, name: ' All Terminals' })
            // component_x.sort(component_x.terminalOptions);
            this.terminalOptions = this.terminalOptions.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        convertToCurrency(num) {
            return (num + 1e-7).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        },
        convertTextToStrong(data) {
            return `<strong>${data}</strong>`
        },
        formatEmpltyCell(data) {
            return `<center>${data}</center>`
        },
        openNotificationWithIcon(type, msg) {
            this.$notification[type]({
                message: 'Export Error',
                description: msg
            });
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        financialSectionRows(report, columns) {
            const row = (label, count = '', amount = null) => {
                const cells = Array(columns).fill('');
                cells[0] = columns === 4 ? {content: label, styles: {halign: 'left'}} : label;
                cells[2] = count === '' ? '' : Number(count || 0);
                cells[columns - 1] = amount === null ? '' : this.convertToCurrency(Number(amount || 0));
                return cells;
            };
            const heading = label => {
                const cells = row(label);
                if (columns === 4) cells[0].styles.fontStyle = 'bold';
                return cells;
            };
            const transactions = [];
            (report.transaction_types || []).forEach(type => {
                transactions.push(row(type.code, type.Count, type.Total));
                ['adjNet', 'adjNet2', 'adjTax', 'Vatable', 'Vat_exempt_sales', 'Zero_rated_sales', 'Vat'].forEach(key => {
                    transactions.push(row(`  ${key.toUpperCase().replace(/_/g, ' ')}`, '', type[key]));
                });
                (type.sub_segments || []).forEach(segment => {
                    transactions.push(row(`  - ${segment.name || 'NO SUB SEGMENT'}`, segment.count, segment.total));
                });
            });
            return {
                transactions,
                categories: (report.categories || []).map(item => row(`${item.name || item.code} GROSS`, '', item.gross)),
                payments: (report.payments || []).map(item => row(item.name || item.code, item.count, item.total)),
                collections: (report.collections || []).map(item => row(item.name || item.code, item.count, item.total)),
                reasons: (report.reason_types || []).map(item => row(item.name, item.count, item.total)),
                voids: [row('VOID TOTAL', '', report.void_total), row('VOID ITEM', report.void_item)],
                tran: [row('TRAN', report.tran_count)],
                cashiers: (report.cashiers || []).length ? [heading('CASHIERS'), ...(report.cashiers || []).map(name => row(`CASHIER: ${name}`))] : [],
                cashTotals: [heading('CASH TOTALS')],
                runningAdjusted: report.display_adj_net ? [row('ADJ NET', '', report.running_adj_net)] : [],
                adjusted: report.display_adj_net ? [row('ADJ NET', '', report.report_adj_net)] : [],
                zeroRated: [row('NET ZERO-RATED SALES', '', report.report_zero_rated)]
            };
        },
        generateReport: async function () {
            // pdf
            this.spinning = true;
            let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
            let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
            let report_from_date = this.inputDate[0].format('YYYY-MM-DD');
            let report_to_date = this.inputDate[1].format('YYYY-MM-DD');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'financial_reports?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&terminal_id=' + this.inputTerminal, null);

                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    this.spinning = false;
                    return
                }

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Export Error', 'Please make sure to check your current filters.');
                    return
                }
                let reportLogo = document.getElementById('reportLogo');

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){

                    if(siteSpecific[0].report_details[0].site_name == null){
                        this.openNotificationWithIcon('info', 'No Data Found', 'Please make sure to check your current filters.');
                        this.spinning= false;
                        return
                    }

                    let doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'b3' });

                    for(var x=0; x < siteSpecific.length; x++){
                        if(x > 0){
                            doc.addPage();
                        }

                        const logoWidth = reportLogo.naturalWidth || reportLogo.width;
                        const logoHeight = reportLogo.naturalHeight || reportLogo.height;
                        const logoScale = Math.min(30 / logoWidth, 15 / logoHeight);
                        doc.addImage(reportLogo, "PNG", 10, 5, logoWidth * logoScale, logoHeight * logoScale);

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        let design_y = 20
                        design_y = design_y + 5;
                        doc.text(15,design_y,`Financial Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(12);

                        // design_y = design_y + 5;
                        // doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                        design_y = design_y + 5;
                        doc.setFontSize(10)
                        doc.text(15,design_y,"Store Name: " + siteSpecific[x].report_details[0].site_name)
                        // design_y = design_y + 5;
                        // doc.text(15,design_y,"Store Name: " + siteSpecific[x].report_details[0].site_name)

                        // start
                        this.birSalesReports = siteSpecific[x].report_details

                        let detailColStyles = {
                            0: {cellWidth: 60},
                            1: {cellWidth: 25},
                            2: {cellWidth: 20},
                            3: {cellWidth: 30},   
                        } 
                        
                        let header = [
                            {content: '', styles: {halign: 'center'}},
                            {content: '', styles: {halign: 'center'}},
                            {content: '', styles: {halign: 'center'}},
                            {content: '', styles: {halign: 'center'}},
                        ]
                 
                        if(this.birSalesReports.length > 0){
                            let reportData = []
        
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                             
                                // let report_separator = [{content:'-------------------------------------------------', styles: { halign: 'left'}}]
                                // let report_separator_end = [{content:'', styles: { halign: 'left'}}, '','---------------------------']
                                let report_running_totals_to_date = [{content:'RUNNING TOTALS TO DATE', styles: {fontStyle: 'bold',  halign: 'left', cellPadding: {top: 3.5, right: 1, bottom: 3.5, left: 1} }}, '','','']
                                let report_totals = [{content:'REPORT TOTALS', styles: { fontStyle: 'bold',  halign: 'left', cellPadding: {top: 3.5, right: 1, bottom: 3.5, left: 1}}}, '','','']
                                let report_date_from = [{content:'Report Date: ', styles: { halign: 'left'}},  {content:`${report_from_date}`, styles: { halign: 'left'}}, '', '']
                                let report_date_to = [{content:'', styles: { halign: 'left'}}, {content:`${report_to_date}`, styles: { halign: 'left', cellPadding: {top: 1, right: 1, bottom: 3, left: 1}}}, '', '']

                                // details for running totals from live to date 
                                let report_from_live_gross = [{content:'GROSS', styles: { halign: 'left', cellPadding: {top: 2, right: 1, bottom: 1, left: 1}}}, '', '', {content: this.convertToCurrency(Number(reportLine.running_gross)), styles: {cellPadding: {top: 2, right: 1, bottom: 1, left: 1}}}]
                                let report_from_live_less_discount = [{content:'LESS DISCOUNT', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.running_less_discount))]
                                let report_from_live_vat_exempt = [{content:'12% VAT-EXEMPT', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.running_vat_exempt))]
                                let report_from_live_gross_less_discount = [{content:'GROSS LESS DEDUCTIONS', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.running_gross_less_discount))]
                                let report_from_live_net = [{content:'NET', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.running_net))]
                                let report_from_live_vat = [{content:'12% VAT', styles: { halign: 'left', cellPadding: {top: 1, right: 1, bottom: 3, left: 1}}}, '', '',  this.convertToCurrency(Number(reportLine.running_vat))]

                                // details for report totals
                                let report_gross = [{content:'GROSS', styles: { halign: 'left', cellPadding: {top: 2, right: 1, bottom: 1, left: 1}}},'', '',  {content: this.convertToCurrency(Number(reportLine.report_gross)), styles: {cellPadding: {top: 2, right: 1, bottom: 1, left: 1}}}]
                                let report_less_discount = [{content:'LESS DISCOUNT', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_less_discount))]
                                let report_gross_less_discount = [{content:'GROSS LESS DEDUCTIONS', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_gross_less_discount))]
                                let report_net = [{content:'NET', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_net))]
                                let report_vat = [{content:'12% VAT', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_vat))]
                                let report_vatable_sales = [{content:'NET VATABLE SALES', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_vatable_sales))]
                                let report_non_vatable_sales = [{content:'NET VAT-EXEMPT SALES', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_vat_exempt_sales))]
                                let report_vat_exempt = [{content:'12% VAT-EXEMPT', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_vat_exempt))]

                                let report_count_amount = ['', '',  {content:'COUNT', styles: {fontStyle: 'bold'}},  {content:'AMOUNT', styles: {fontStyle: 'bold'}}]
                                
                                let report_collection_label = [{content:'COLLECTIONS', styles: {fontStyle: 'bold', halign: 'left'}}, '',  '',   '']
                                let report_space = ['','','','']

                                const sections = this.financialSectionRows(reportLine, 4);
                                const report_trans_types = sections.transactions;
                                const report_categories = sections.categories;
                                const report_reason_types = sections.reasons;

                                let report_trans_count = [{content:'TRANSACTION COUNT', styles: { halign: 'left'}}, '',  reportLine.transaction_count, '']
                                let report_guest_count = [{content:'GUEST COUNT', styles: { halign: 'left'}}, '',  reportLine.guest_count, '']

                                const report_payments = sections.payments;
                                const report_collections = sections.collections;

                                // loyalty points
                                let report_award_count = [{content:'AWARD COUNT', styles: { halign: 'left'}}, '',  '',  reportLine.award_count]
                                let report_award_points = [{content:'AWARD POINTS', styles: { halign: 'left'}}, '',  '',  reportLine.award_points]

                                let report_first_trans_no = [{content:'FIRST TRAN NO', styles: { halign: 'left'}}, '', '',  reportLine.first_txn_no]
                                let report_last_trans_no = [{content:'LAST TRAN NO', styles: { halign: 'left'}}, '', '',  reportLine.last_txn_no]
                                let report_first_invoice_no = [{content:'FIRST INV NO', styles: { halign: 'left'}}, '', '',  reportLine.first_invoice_no]
                                let report_last_invoice_no = [{content:'LAST INV NO', styles: { halign: 'left'}}, '', '',  reportLine.last_invoice_no]
                                let report_invoice_total = [{content:'INVOICE TOTAL', styles: { halign: 'left'}}, '', '',  reportLine.invoice_total]
                                let report_z_counter = [{content:'Z-READING COUNTER', styles: { halign: 'left'}}, '', '',  reportLine.z_reading_counter]
                                let report_prev_sales = [{content:'OLD SALES', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.previous_sales))]
                                let report_new_sales = [{content:'NEW SALES', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.new_sales))]

                                // additional columns #5125
                                let report_cancelled = [{content: 'CANCELLED', styles: { halign: 'left'}}, '', reportLine.cancelled_tran, this.convertToCurrency(Number(reportLine.cancelled_total))];
                                let report_cancelled_item =  [{content: 'CANCELLED ITEM', styles: { halign: 'left'}}, '', reportLine.cancelled_item, ''];
                                let report_refund = [{content: 'REFUND', styles: { halign: 'left'}}, '', reportLine.refund_tran, this.convertToCurrency(Number(reportLine.refund_total))];
                                let report_refund_item =  [{content: 'REFUND ITEM', styles: { halign: 'left'}}, '', reportLine.refund_item, ''];
                                let report_open_checks = [{content: 'OPEN CHECKS', styles: { halign: 'left'}}, '', reportLine.open_check_count, this.convertToCurrency(Number(reportLine.open_check_total))];
                                let report_total_cash = [{content:'TOTAL CASH', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.total_cash))]
                                let report_total_cash_dep = [{content:'TOTAL CASH DEPOSIT', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.total_deposit))]
                                let report_total_cash_wdl = [{content:'TOTAL CASH WITHDRAWAL', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.total_withdrawal))]
                                let report_total_cash_over_short = [{content:'TOTAL OVER/SHORT', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.total_over_short))]
                                let report_avg_txn = [{content:'AVERAGE PER TRANSACTION', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.avg_per_txn))]
                                let report_payment_label = [{content:'TENDER TOTALS', styles: {fontStyle: 'bold', halign: 'left'}}, '',  '',   '']
                                let report_discount_label = [{content:'DISCOUNTS', styles: {fontStyle: 'bold', halign: 'left'}}, '',  '',   '']
                                let report_discount_regular =  [{content: 'REGULAR', styles: { halign: 'left'}}, '', reportLine.discount_reg_count, this.convertToCurrency(Number(reportLine.discount_reg_total))];
                                let report_discount_sc = [{content: 'SC', styles: { halign: 'left'}}, '', reportLine.discount_sc_count, this.convertToCurrency(Number(reportLine.discount_sc_total))];
                                let report_discount_pwd = [{content: 'PWD', styles: { halign: 'left'}}, '', reportLine.discount_pwd_count, this.convertToCurrency(Number(reportLine.discount_pwd_total))];
                                let report_discount_pnstm = [{content: reportLine.discount_pnstm_label || 'PNSTM', styles: { halign: 'left'}}, '', reportLine.discount_pnstm_count, this.convertToCurrency(Number(reportLine.discount_pnstm_total))];
                                let report_discount_mov = [{content: 'MOV', styles: { halign: 'left'}}, '', reportLine.discount_mov_count, this.convertToCurrency(Number(reportLine.discount_mov_total))];
                                let report_discount_supercard = [{content: 'SUPERCARD', styles: { halign: 'left'}}, '', reportLine.discount_supercard_count, this.convertToCurrency(Number(reportLine.discount_supercard_total))];

                                let sub_end_line = [{content:`Site Name: ${reportLine.site_name}`, styles: {fontStyle: 'bold', halign: 'left'}}, '', '', '']
                                let end_line = []
                                if (this.inputTerminal == 0){
                                    end_line = [{content:`Terminal Name: All Terminals`, styles: {fontStyle: 'bold', halign: 'left'}}, '', '', '']
                                } else {
                                    end_line = [{content:`Terminal Name: ${reportLine.terminal_name}`, styles: {fontStyle: 'bold', halign: 'left'}}, '', '', '']
                                }

                                // REPORT DATE
                                reportData.push(report_date_from)
                                reportData.push(report_date_to)

                                // // RUNNING TOTALS TO DATE
                                reportData.push(Object.assign({}, ["rowLine"]))
                                reportData.push(report_running_totals_to_date)
                                reportData.push(Object.assign({}, ["rowLine"]))

                                reportData.push(report_from_live_gross)
                                reportData.push(report_from_live_less_discount)
                                reportData.push(report_from_live_vat_exempt)
                                reportData.push(report_from_live_gross_less_discount)
                                reportData.push(report_from_live_net)
                                reportData = reportData.concat(sections.runningAdjusted);
                                reportData.push(report_from_live_vat)

                                //  TOTALS 
                                reportData.push(Object.assign({}, ["rowLine"]))
                                reportData.push(report_totals)
                                reportData.push(Object.assign({},["rowLine"]))
                               
                                reportData.push(report_gross)
                                reportData.push(report_less_discount)
                                reportData.push(report_vat_exempt)
                                reportData.push(report_gross_less_discount)
                                reportData.push(report_net)
                                reportData = reportData.concat(sections.adjusted);
                              
                                reportData.push(report_vat)
                                reportData.push(report_vatable_sales)
                                reportData.push(report_non_vatable_sales)
                                reportData = reportData.concat(sections.zeroRated);
                                

                                reportData.push(report_count_amount)
                                
                                reportData = reportData.concat(report_trans_types);

                                reportData = reportData.concat(report_categories);

                                reportData.push(report_cancelled)
                                reportData.push(report_cancelled_item)
                                reportData.push(report_refund)
                                reportData.push(report_refund_item)
                                reportData = reportData.concat(sections.voids);
                                reportData = reportData.concat(report_reason_types);
                                reportData.push(report_trans_count)
                                reportData.push(report_guest_count)
                                reportData.push(report_avg_txn)
                                reportData.push(report_open_checks)

                                

                                reportData.push(report_count_amount)

                                   // payment_types
                                reportData.push(report_payment_label);
                                reportData = reportData.concat(report_payments);
                                reportData.push(Object.assign({}))

                                // discounts
                                reportData.push(report_discount_label);
                                reportData.push(report_discount_regular);
                                reportData.push(report_discount_sc);
                                reportData.push(report_discount_pwd);
                                reportData.push(report_discount_pnstm);
                                reportData.push(report_discount_mov);
                                reportData.push(report_discount_supercard);
                                reportData.push(Object.assign({}))

                            // collections
                            reportData.push(report_collection_label)
                            reportData = reportData.concat(report_collections);

                            reportData.push(Object.assign({}))

                                // loyalty points
                                reportData.push(report_award_count)
                                reportData.push(report_award_points)

                                reportData = reportData.concat(sections.tran);
                                reportData.push(report_first_trans_no)
                                reportData.push(report_last_trans_no)
                                reportData.push(report_first_invoice_no)
                                reportData.push(report_last_invoice_no)
                                reportData.push(report_invoice_total)
                                reportData.push(report_z_counter)
                                reportData.push(report_prev_sales)
                                reportData.push(report_new_sales)

                                reportData = reportData.concat(sections.cashiers);
                                reportData = reportData.concat(sections.cashTotals);
                                reportData.push(report_total_cash)
                                reportData.push(report_total_cash_dep)
                                reportData.push(report_total_cash_wdl)
                                reportData.push(report_total_cash_over_short)

                                reportData.push(Object.assign({}))
                                reportData.push(sub_end_line)
                                reportData.push(end_line)
                                
                                if(i == this.birSalesReports.length-1){
                                    
                                    design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y,
                                        head: [header],
                                        body: reportData,
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        showHead: 'never',
                                        styles: {
                                            cellPadding: 1.0,
                                            fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0,0,0]
                                                data.cell.styles.fontSize = 0.6
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        },
                                    });
                                } 
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                     for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        doc.setFontSize(9)
                        // doc.text(330, 490,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                         reportUtils.pdfTools.addFooter(doc, printed_by, "Financial Report", 330, 487, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('info', 'No Data Found', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                 let report_from_date = this.inputDate[0].format('YYYY-MM-DD');
                let report_to_date = this.inputDate[1].format('YYYY-MM-DD');

                
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'financial_reports?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&terminal_id=' + this.inputTerminal, null);

                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    this.spinning = false;
                    return
                }

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Export Error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){

                     if(siteSpecific[0].report_details[0].site_name == null){
                        this.openNotificationWithIcon('info', 'No Data Found', 'Please make sure to check your current filters.');
                        this.spinning= false;
                        return
                    }

                    let reportData = [];
                
                    for(var x=0; x < siteSpecific.length; x++){
                            
                        this.birSalesReports = siteSpecific[x].report_details

                        if(this.birSalesReports.length > 0){
                            
                            let grouper = 'start'
                            
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                // body
                                // labels
                                let report_separator = ['-------------------------------------------------', '', '', '', '']
                                let report_separator_end = ['', '','---------------------------', '--------------']
                                let report_running_totals_to_date = ["RUNNING TOTALS TO DATE", '','','','']
                                let report_totals = ["REPORT TOTALS", '','','','']
                                let report_date_from = ['Report Date: ',  `${report_from_date}`, '', '','']
                                let report_date_to = ['',  `${report_to_date}`, '', '','']

                                // details for running totals from live to date 
                                let report_from_live_gross = ['GROSS', '', '','', this.convertToCurrency(Number(reportLine.running_gross))]
                                let report_from_live_less_discount = ['LESS DISCOUNT', '', '', '', this.convertToCurrency(Number(reportLine.running_less_discount))]
                                let report_from_live_vat_exempt = ['12% VAT-EXEMPT', '', '', '', this.convertToCurrency(Number(reportLine.running_vat_exempt))]
                                let report_from_live_gross_less_discount = ['GROSS LESS DEDUCTIONS', '', '', '', this.convertToCurrency(Number(reportLine.running_gross_less_discount))]
                                let report_from_live_net = ['NET', '', '','',  this.convertToCurrency(Number(reportLine.running_net))]
                                let report_from_live_vat = ['12% VAT', '', '','',  this.convertToCurrency(Number(reportLine.running_vat))]

                                // details for report totals
                                let report_gross = ['GROSS', '', '', '', this.convertToCurrency(Number(reportLine.report_gross))]
                                let report_less_discount = ['LESS DISCOUNT', '', '','',  this.convertToCurrency(Number(reportLine.report_less_discount))]
                                let report_gross_less_discount = ['GROSS LESS DEDUCTIONS', '', '','',  this.convertToCurrency(Number(reportLine.report_gross_less_discount))]
                                let report_net = ['NET', '', '', '', this.convertToCurrency(Number(reportLine.report_net))]
                                let report_vat = ['12% VAT', '', '', '', this.convertToCurrency(Number(reportLine.report_vat))]
                                let report_vatable_sales = ['NET VATABLE SALES', '', '','',  this.convertToCurrency(Number(reportLine.report_vatable_sales))]
                                let report_non_vatable_sales = ['NET VAT-EXEMPT SALES', '', '','',  this.convertToCurrency(Number(reportLine.report_vat_exempt_sales))]
                                let report_vat_exempt = ['12% VAT-EXEMPT', '', '','',  this.convertToCurrency(Number(reportLine.report_vat_exempt))]

                                let report_count_amount = ['', '',  "COUNT",'', "AMOUNT"]
                                let report_collection_label = ["COLLECTIONS", '', '', '', '']
                                let report_space = ['','','','', '']

                                const sections = this.financialSectionRows(reportLine, 5);
                                const report_trans_types = sections.transactions;
                                const report_categories = sections.categories;
                                const report_reason_types = sections.reasons;

                                let report_trans_count = ['TRANSACTION COUNT', '',  reportLine.transaction_count,'', '']
                                let report_guest_count = ['GUEST COUNT', '',  reportLine.guest_count,'', '']

                                const report_payments = sections.payments;
                                const report_collections = sections.collections;

                                // loyalty points
                                let report_award_count = ['AWARD COUNT', '',  '', '', reportLine.award_count]
                                let report_award_points = ['AWARD POINTS', '', '', '', reportLine.award_points]

                                let report_first_trans_no = ['FIRST TRAN NO', '', '','',  reportLine.first_txn_no]
                                let report_last_trans_no = ['LAST TRAN NO', '', '','',  reportLine.last_txn_no]
                                let report_first_invoice_no = ['FIRST INV NO', '', '','',  reportLine.first_invoice_no]
                                let report_last_invoice_no = ['LAST INV NO', '', '','',  reportLine.last_invoice_no]
                                let report_invoice_total = ['INVOICE TOTAL', '', '','',  reportLine.invoice_total]
                                let report_z_counter = ['ZREADING COUNTER', '', '','',  reportLine.z_reading_counter]
                                let report_prev_sales = ['OLD SALES', '', '', '', this.convertToCurrency(Number(reportLine.previous_sales))]
                                let report_new_sales = ['NEW SALES', '', '','',  this.convertToCurrency(Number(reportLine.new_sales))]


                                // ADDITIONAL FIELDS #5125
                                let report_refund = ['REFUND', '', '', reportLine.refund_tran,  this.convertToCurrency(Number(reportLine.refund_total))]
                                let report_refund_item = ['REFUND ITEM', '', '', reportLine.refund_item, '']
                                let report_cancelled = ['CANCELLED', '', '', reportLine.cancelled_tran,  this.convertToCurrency(Number(reportLine.cancelled_total))]
                                let report_cancelled_item = ['CANCELLED ITEM', '', '', reportLine.cancelled_item, '']
                                let report_open_checks = ['OPEN CHECKS', '', '', reportLine.open_check_count, this.convertToCurrency(Number(reportLine.open_check_total))]
                                let report_total_cash = ['TOTAL CASH', '', '', '', this.convertToCurrency(Number(reportLine.total_cash))]
                                let report_total_cash_dep = ['TOTAL CASH DEPOSIT', '', '', '', this.convertToCurrency(Number(reportLine.total_deposit))]
                                let report_total_cash_wdl = ['TOTAL CASH WITHDRAWAL', '', '', '', this.convertToCurrency(Number(reportLine.total_withdrawal))]
                                let report_total_cash_over_short = ['TOTAL OVER/SHORT', '', '', '', this.convertToCurrency(Number(reportLine.total_over_short))]
                                let report_avg_txn = ['AVERAGE PER TRANSACTION', '', '', '', this.convertToCurrency(Number(reportLine.avg_per_txn))]
                                let report_payment_label = ['TENDER TOTALS', '', '', '', '']
                                let report_discount_label = ['DISCOUNTS', '', '', '', '']
                                let report_discount_regular = ['REGULAR', '', '', reportLine.discount_reg_count, this.convertToCurrency(Number(reportLine.discount_reg_total))]
                                let report_discount_sc = ['SC', '', '', reportLine.discount_sc_count, this.convertToCurrency(Number(reportLine.discount_sc_total))]
                                let report_discount_pwd = ['PWD', '', '', reportLine.discount_pwd_count, this.convertToCurrency(Number(reportLine.discount_pwd_total))]
                                let report_discount_pnstm = [reportLine.discount_pnstm_label || 'PNSTM', '', '', reportLine.discount_pnstm_count, this.convertToCurrency(Number(reportLine.discount_pnstm_total))]
                                let report_discount_mov = ['MOV', '', '', reportLine.discount_mov_count, this.convertToCurrency(Number(reportLine.discount_mov_total))]
                                let report_discount_supercard = ['SUPERCARD', '', '', reportLine.discount_supercard_count, this.convertToCurrency(Number(reportLine.discount_supercard_total))]


                                let sub_end_line = [`Site Name: ${reportLine.site_name}`, '', '','', '']
                                let end_line = []
                                if (this.inputTerminal == 0){
                                    end_line = [`Terminal Name: All Terminals`, '', '', '','']
                                } else {
                                    end_line = [`Terminal Name: ${reportLine.terminal_name}`, '', '', '','']
                                }


                                // REPORT DATE
                                reportData.push(report_date_from)
                                reportData.push(report_date_to)

                                // // RUNNING TOTALS TO DATE
                                reportData.push(report_separator)
                                reportData.push(report_running_totals_to_date)
                                reportData.push(report_separator)

                                reportData.push(report_from_live_gross)
                                reportData.push(report_from_live_less_discount)
                                reportData.push(report_from_live_vat_exempt)
                                reportData.push(report_from_live_gross_less_discount)
                                reportData.push(report_from_live_net)
                                reportData = reportData.concat(sections.runningAdjusted);
                                reportData.push(report_from_live_vat)
                                

                                //  TOTALS 
                                reportData.push(report_separator)
                                reportData.push(report_totals)
                                reportData.push(report_separator)

                                reportData.push(report_gross)
                                reportData.push(report_less_discount)
                                reportData.push(report_vat_exempt)
                                reportData.push(report_gross_less_discount)
                                reportData.push(report_net)
                                reportData = reportData.concat(sections.adjusted);
                                reportData.push(report_vat)
                                reportData.push(report_vatable_sales)
                                reportData.push(report_non_vatable_sales)
                                reportData = reportData.concat(sections.zeroRated);

                                reportData.push(report_count_amount)
                                
                                reportData = reportData.concat(report_trans_types);

                                reportData = reportData.concat(report_categories);

                                reportData.push(report_cancelled)
                                reportData.push(report_cancelled_item)
                                reportData.push(report_refund)
                                reportData.push(report_refund_item)
                                reportData = reportData.concat(sections.voids);
                                reportData = reportData.concat(report_reason_types);
                                reportData.push(report_trans_count)
                                reportData.push(report_guest_count)
                                reportData.push(report_avg_txn)
                                reportData.push(report_open_checks)

                                

                                reportData.push(report_count_amount)

                                

                                // payment_types
                                reportData.push(report_payment_label)
                                reportData = reportData.concat(report_payments);
                                reportData.push(['','','','',''])

                                // discounts
                                reportData.push(report_discount_label)
                                reportData.push(report_discount_regular)
                                reportData.push(report_discount_sc)
                                reportData.push(report_discount_pwd)
                                reportData.push(report_discount_pnstm)
                                reportData.push(report_discount_mov)
                                reportData.push(report_discount_supercard)
                                reportData.push(['','','','',''])

                            // collections
                            reportData.push(report_collection_label)
                            reportData = reportData.concat(report_collections);
                            
                            reportData.push(['', '', '', '', ''])
                            // loyalty points
                            reportData.push(report_award_count)
                            reportData.push(report_award_points)

                                reportData = reportData.concat(sections.tran);
                                reportData.push(report_first_trans_no)
                                reportData.push(report_last_trans_no)
                                reportData.push(report_first_invoice_no)
                                reportData.push(report_last_invoice_no)
                                reportData.push(report_invoice_total)
                                reportData.push(report_z_counter)
                                reportData.push(report_prev_sales)
                                reportData.push(report_new_sales)

                                reportData = reportData.concat(sections.cashiers);
                                reportData = reportData.concat(sections.cashTotals);
                                reportData.push(report_total_cash)
                                reportData.push(report_total_cash_dep)
                                reportData.push(report_total_cash_wdl)
                                reportData.push(report_total_cash_over_short)

                                 reportData.push(sub_end_line)
                                 reportData.push(end_line)

                                
                            }
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(['','','','',''])
                        reportData.push(["Financial Report", "Generated By: " + printed_by,"","For the Period of " + report_from_date + " to " + report_to_date, ""])
                        reportData.push(['','','','',''])

                        this.JsonData = reportData;
                    }
                    
                } else {
                    this.openNotificationWithIcon('info', 'No Data Found', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>
